import * as React from 'react';
import styled from 'styled-components';
import { laptopSize, mobileSize } from '../../../util/variables';
import theme from '../../../util/theme';

const organizations = [
  {
    id: 'org_codepath',
    alt: 'CodePath',
  },
  {
    id: 'org_illumyn_impact',
    alt: 'Illumyn Impact',
  },
  {
    id: 'org_pri',
    alt: 'Principles for Responsible Investment',
  },
  {
    id: 'org_bvcc',
    alt: 'Black Venture Capital Consortium',
  },
  {
    id: 'org_idac',
    alt: 'IDAC - Inclusion in Finance',
  },
  {
    id: 'org_esg_data_convergence',
    alt: 'ESG Data Convergence Initiative',
  },
  {
    id: 'org_b-tech',
    alt: 'B-Tech',
  },
  {
    id: 'org_venture_esg',
    alt: 'Venture ESG',
  },
];

const universities = [
  {
    id: 'uni_howard',
    alt: 'Howard University',
  },
  {
    id: 'uni_morehouse',
    alt: 'Morehouse College',
  },
  {
    id: 'uni_spelman',
    alt: 'Spelman College',
  },
  {
    id: 'uni_dc',
    alt: 'University of the District of Columbia',
  },
  {
    id: 'uni_bethune',
    alt: 'Bethune-Cookman University',
  },
  {
    id: 'uni_alabama',
    alt: 'Alabama A&M University',
  },
  {
    id: 'uni_asu',
    alt: 'Alabama State University',
  },
  {
    id: 'uni_jackson',
    alt: 'Jackson State University',
  },
  {
    id: 'uni_fisk',
    alt: 'Fisk University',
  },
  {
    id: 'uni_virginia',
    alt: 'Virginia State University',
  },
  {
    id: 'uni_philander',
    alt: 'Philander Smith College',
  },
  {
    id: 'uni_florida',
    alt: 'Florida A&M University',
  },
  {
    id: 'uni_rust',
    alt: 'Rust College',
  },
  {
    id: 'uni_nc_atsu',
    alt: 'North Carolina A&T State University',
  },
  {
    id: 'uni_shaw',
    alt: 'Shaw University',
  },
  {
    id: 'uni_grambling',
    alt: 'Grambling State University',
  },
  {
    id: 'org_sfi',
    alt: 'Student Freedom Initiative',
  },
];

const OrganizationCollaborations: React.FC = () => {
  return (
    <Container>
      <ContentWrapper>
        <div>
          <Title>We are proud to support and collaborate with</Title>
          <LogoGrid>
            {organizations.map(org => (
              <LogoWrapper key={org.id}>
                <img
                  src={require(`../../../../static/img/partners/${org.id}.png`)}
                  alt={org.alt}
                  draggable="false"
                  style={{ maxWidth: '100%', maxHeight: '100%' }}
                />
              </LogoWrapper>
            ))}
          </LogoGrid>
        </div>
        <div>
          <Title>
            We are proud to have worked with students from 300+ colleges and universities, including
          </Title>
          <LogoGrid>
            {universities.map(uni => (
              <LogoWrapper key={uni.id}>
                <img
                  src={require(`../../../../static/img/partners/${uni.id}.png`)}
                  alt={uni.alt}
                  draggable="false"
                  style={{ maxWidth: '100%', maxHeight: '100%' }}
                />
              </LogoWrapper>
            ))}
          </LogoGrid>
        </div>
      </ContentWrapper>
    </Container>
  );
};

const Container = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: ${theme.WHITE_COLOR};
`;

const ContentWrapper = styled.div`
  max-width: 1200px;
  width: 100%;
  padding: 110px 44px;
  display: flex;
  flex-direction: column;
  gap: 100px;

  @media ${laptopSize} {
    padding: 40px 44px 80px 44px;
  }
`;

const Title = styled.h2`
  font-size: 36px;
  line-height: 1.2;
  color: ${theme.BLACK_COLOR};
  margin-bottom: 40px;
  text-align: left;

  @media ${laptopSize} {
    font-size: 24px;  
  }
`;

const LogoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  align-items: center;
  justify-items: center;
  margin: 0 auto;
  max-width: 1200px;
  gap: 40px 80px;
  
  @media ${laptopSize} {
    grid-template-columns: repeat(3, 1fr);
  }
  
  @media ${mobileSize} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const LogoWrapper = styled.div`
  width: auto;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  @media ${mobileSize} {
    height: 60px;
  }
`;

export default OrganizationCollaborations;
